import sanitizeHtml from 'sanitize-html';

export function cleanUpText(text: string): string {
  return sanitizeHtml(text, {
    allowedTags: [],
    disallowedTagsMode: 'recursiveEscape',
  });
}
